import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
//import { GlobalService } from './global.service';
import { map, Observable, of, switchMap, throwError } from 'rxjs';
//import { WorkspaceService } from '../../workspace/workspace.service';
//import { any } from '@uirouter/core';
import { ActionResponse } from '../../shared/_models/action-response.model';
import { GtwSnackbarService } from './gtw-snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class JsonObjectFactoryService {
  constructor(
    private http: HttpClient,
    //private GlobalService: GlobalService,
    private gtwSnackbarService: GtwSnackbarService
    //private workspaceFactory: WorkspaceService
  ) {}
  private checkLockedbj: Array<any> = [];

  private getWorkspaceFilterParams(_globalService: any): any {
    if (
      _globalService?.workspaceFactory?.activeScreen?.filters &&
      typeof _globalService.workspaceFactory.activeScreen.filters.getFilterParams === 'function'
    ) {
      return _globalService.workspaceFactory.activeScreen.filters.getFilterParams();
    }
    return {};
  }

  private getGlobalServiceFilterParams(_globalService: any): any {
    // Migration-safe hook: supports service-based and component-provided contexts.
    if (_globalService?.filterParams && _.isObject(_globalService.filterParams)) {
      return _globalService.filterParams;
    }
    if (
      typeof _globalService?.getFilterParams === 'function' &&
      _.isObject(_globalService.getFilterParams())
    ) {
      return _globalService.getFilterParams();
    }
    return {};
  }

  private resolveFilterParams(_globalService: any, _componentFilterParams: any = {}): any {
    const componentFilterParams = _.isObject(_componentFilterParams) ? _componentFilterParams : {};
    const serviceFilterParams = this.getGlobalServiceFilterParams(_globalService);
    const workspaceFilterParams = this.getWorkspaceFilterParams(_globalService);

    // Priority: explicit component filter params > service-provided filter params > workspace filters.
    return _.merge({}, workspaceFilterParams, serviceFilterParams, componentFilterParams);
  }

  /* save JSON  */
  saveJSON(_url: string, _data: any, _globalService: any): Observable<any> {
    let filterParams = this.resolveFilterParams(_globalService);
    console.log('___data', _data);
    let rowData =
      _globalService.workspaceFactory.activeScreen.data &&
      _globalService.workspaceFactory.activeScreen.data.selected &&
      _globalService.workspaceFactory.activeScreen.data.selected.rowData;
    if (_.isArray(rowData) && rowData.length > 0) {
      _.each(rowData, (item: any) => {
        this.checkLockedbj.push({
          leid: item.data.LEID || item.data.SOURCE_LEID, //"IF1139",
          me_code:
            item.data.ME_CODE || item.data.ME || item.data.SOURCE_ME_CODE,
          cdr_number:
            //need to check item.data.CDR_NO || rowData.TAX_CODE || item.data.SOURCE_CDR_NO,
            item.data.CDR_NO || item.data.TAX_CODE || item.data.SOURCE_CDR_NO,
          consol_group_key:
            item.data.CONSOL_GROUP_KEY || item.data.FILING_GROUP, //1,
          reporting_period:
            item.data.REPORTING_PERIOD || item.data.SOURCE_REPORTING_PERIOD,
          combination_key:
            item.data.COMBINATION_KEY ||
            item.data.COMPL_COMBINATION_KEY ||
            item.data.HO_COMBINATION_KEY, //1,
          scenario_key: item.data.SCENARIO_KEY
            ? item.data.SCENARIO_KEY
            : _data.scenario
            ? _data.scenario
            : filterParams.scenario,
        });
      });
    } else if (rowData) {
      this.checkLockedbj.push({
        leid: rowData.LEID || rowData.SOURCE_LEID, //"IF1139",
        me_code: rowData.ME_CODE || rowData.ME || rowData.SOURCE_ME_CODE,
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE || rowData.SOURCE_CDR_NO,
        consol_group_key: rowData.CONSOL_GROUP_KEY || rowData.FILING_GROUP, //1,
        reporting_period:
          rowData.REPORTING_PERIOD || rowData.SOURCE_REPORTING_PERIOD,
        combination_key:
          rowData.COMBINATION_KEY ||
          rowData.COMPL_COMBINATION_KEY ||
          rowData.HO_COMBINATION_KEY,
        scenario_key: rowData.SCENARIO_KEY
          ? rowData.SCENARIO_KEY
          : _data.scenario
          ? _data.scenario
          : filterParams.scenario,
      });
    } else {
      this.checkLockedbj.push({
        scenario_key: _data.scenario ? _data.scenario : filterParams.scenario,
      });
    }
    if (
      _globalService.workspaceFactory.activeScreen &&
      (_globalService.workspaceFactory.activeScreen.screen_key ==
        10305 ||
        _globalService.workspaceFactory.activeScreen.screen_key == 10072)
    ) {
      /* these screens have only filing group locking FIR*/
      this.checkLockedbj = [];
      this.checkLockedbj.push({ consol_group_key: rowData.FILING_GROUP });
    }
    _data.tax_year = _data.tax_year ? _data.tax_year : filterParams.tax_year;
    _data.scenario = _data.scenario ? _data.scenario : filterParams.scenario;
    _data.jcd_key = _globalService.globalParams.jcd_key;
    _data.issue_id = _globalService.globalParams.issue_id;
    _data.issue_short_desc =
    _globalService.globalParams.issue_short_desc;
    _data.checkLockedbj = JSON.stringify(this.checkLockedbj);

    let scenarioCode: any;
    if (
      _globalService.workspaceFactory.activeScreen &&
      _globalService.workspaceFactory.activeScreen.filters &&
      typeof _globalService.workspaceFactory.activeScreen.filters
        .getFilters === 'function'
    ) {
      /*  scenarioCode =  workspaceFactory.activeScreen.filters.getFilters().length>1 ?
                         _.filter(workspaceFactory.activeScreen.filters.getFilters(),{param_name:'scenario'})[0].selected : '';//_.filter(workspaceFactory.activeScreen.filters.getFilters(),{param_name:'scenario'})[0].selected;
                         _data.scenarioCode = scenarioCode.CODE; */
      let foundScenario: any = _.find(
        _globalService.workspaceFactory.activeScreen.filters.getFilters(),
        { param_name: 'scenario' }
      );
      if (foundScenario && foundScenario.selected) {
        scenarioCode = foundScenario.selected;
        _data.scenarioCode = scenarioCode.CODE;
        _data.is_issue_key_enabled = scenarioCode.ISSUE_ID_ENABLED;
      }
    } else if (_data.scenario) {
      //let foundScenario = _.find(GlobalService.inputs.tax_year.values,{scenario:_data.scenario});
      let foundScenario: any;
      _.find(_globalService.inputs.tax_year.values, function (i) {
        if (i.value == _data.tax_year) {
          foundScenario = _.find(i.scenarios, { scenario: _data.scenario });
        }
      });
      if (foundScenario && foundScenario.scenario_type_code) {
        _data.scenarioCode = foundScenario.scenario_type_code;
        _data.is_issue_key_enabled = foundScenario.is_issue_key_enabled;
      }
    }
    const data = new FormData();

    _.map(_data, (v: any, k: any) => {
      if (_data[k] !== null && _data[k] !== undefined && _data[k] !== '') {
        data.append(k, v);
      }
    });
    return this.http.post(_url, data).pipe(
      map((response: any) => {
        if (response.callSuccess == '1') {
          return response;
        }
        this.gtwSnackbarService.openSnackBar(
          'oops  the requested data could not be delivered. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        throwError(new Error('oops!'));
        return response;
      })
    );
  }

  getJsonObj(
    _url: any,
    _params: any,
    filter: any = undefined,
    grp_key: any = undefined
  ): Observable<any> {
    return this.getJSONObj(_url, _params, filter, grp_key);
  }

  /* getJsonObj */
  getJSONObj(
    _url: any,
    _params: any,
    _globalService: any,
    filter: any = undefined,
    grp_key: any = undefined
  ): Observable<any> {
    let filterParams: any = this.resolveFilterParams(_globalService);
    let paramsMerge = _.merge({}, filterParams, _params);
    let params: any = _.merge({}, _globalService.globalParams, paramsMerge);
    delete params.checkLockedbj;
    if (filterParams.tax_year && filterParams.tax_year.length) {
      if (
        (filterParams && filterParams.scenario == undefined) ||
        filterParams.scenario == null
      ) {
        if (_globalService.getScenario(params.tax_year)) {
          params.scenario = _globalService.getScenario(params.tax_year);
        }
      }
    }

    if (grp_key == 25) {
      let params: any = {
        ein: _globalService.getEIN(),
        tax_year: _globalService.getTAXYEAR(),
        entityType: _globalService.getChartType(),
        bsla_key: '',
        reporting_period: '',
      };
      if (filter.refresh_list !== null) {
        var refresh_list = filter.refresh_list.split(',');
        if (refresh_list.length == 1) {
          params.bsla_key = filterParams.BSLA || 0;
        } else if (refresh_list.length == 2) {
          params.reporting_period = filterParams.Reporting_period || 0;
          params.bsla_key = filterParams.BSLA || 0;
        }
      }
      return this.filterApiCall(_url, params);
    } else if (grp_key == 37) {
      let params: any = {
        ein: _globalService.getEIN(),
        tax_year: _globalService.getTAXYEAR(),
        entityType: _globalService.getChartType(),
        leid: '',
        bsla_key: '',
        reporting_period: '',
      };
      if (filter.refresh_list !== null) {
        var refresh_list = filter.refresh_list.split(',');
        if (refresh_list.length == 3) {
          params.bsla_key = filterParams.bsla || 0;
        } else if (refresh_list.length == 4) {
          params.leid = filterParams.LEID || 0;
          params.reporting_period = filterParams.reporting_p || 0;
          params.bsla_key = filterParams.bsla || 0;
        } else if (refresh_list.length == 5) {
          params.reporting_period = filterParams.reporting_p || 0;
          params.bsla_key = filterParams.bsla || 0;
        }
      }
      if (_url.includes('/loadPivotFormJson')) {
        return this.filterPivotFormJson(_url, params);
      }
      if (_url.includes('/loadPivotFormJson')) {
        return this.filterPivotFormJson(_url, params);
      }
      return this.filterApiCall(_url, params);
    }

    if (_url.includes('/loadPivotFormJson')) {
      return this.filterPivotFormJson(_url, params);
    }

    return this.filterApiCall(_url, params);
  }

  /**
   * New explicit 6-parameter API for migrated components:
   * getJSONObj6(url, params, globalService, componentFilterParams, filter, grp_key)
   *
   * - 4th param is component-level filterParams
   * - Existing getJSONObj(...) remains unchanged for backward compatibility
   */
  getJSONObj6(
    _url: any,
    _params: any,
    _globalService: any,
    _componentFilterParams: any = {},
    filter: any = undefined,
    grp_key: any = undefined
  ): Observable<any> {
    const filterParams = this.resolveFilterParams(_globalService, _componentFilterParams);
    const paramsMerge = _.merge({}, filterParams, _params);
    const globalParams = _globalService?.globalParams || {};
    let params: any = _.merge({}, globalParams, paramsMerge);
    delete params.checkLockedbj;

    if (filterParams.tax_year && String(filterParams.tax_year).length) {
      if (
        filterParams.scenario === undefined ||
        filterParams.scenario === null
      ) {
        if (_globalService?.getScenario && _globalService.getScenario(params.tax_year)) {
          params.scenario = _globalService.getScenario(params.tax_year);
        }
      }
    }

    if (grp_key == 25) {
      let grpParams: any = {
        ein: _globalService?.getEIN ? _globalService.getEIN() : '',
        tax_year: _globalService?.getTAXYEAR ? _globalService.getTAXYEAR() : params.tax_year,
        entityType: _globalService?.getChartType ? _globalService.getChartType() : '',
        bsla_key: '',
        reporting_period: '',
      };
      if (filter && filter.refresh_list !== null && filter.refresh_list !== undefined) {
        const refresh_list = String(filter.refresh_list).split(',');
        if (refresh_list.length == 1) {
          grpParams.bsla_key = filterParams.BSLA || 0;
        } else if (refresh_list.length == 2) {
          grpParams.reporting_period = filterParams.Reporting_period || 0;
          grpParams.bsla_key = filterParams.BSLA || 0;
        }
      }
      return this.filterApiCall(_url, grpParams);
    } else if (grp_key == 37) {
      let grpParams: any = {
        ein: _globalService?.getEIN ? _globalService.getEIN() : '',
        tax_year: _globalService?.getTAXYEAR ? _globalService.getTAXYEAR() : params.tax_year,
        entityType: _globalService?.getChartType ? _globalService.getChartType() : '',
      };
      grpParams.bsla_key = params.bsla || 0;
      grpParams.leid = params.LEID || 0;
      grpParams.reporting_period = params.reporting_p || 0;
      if (_url.includes('/loadPivotFormJson')) {
        return this.filterPivotFormJson(_url, grpParams);
      }
      return this.filterApiCall(_url, grpParams);
    }

    if (_url.includes('/loadPivotFormJson')) {
      return this.filterPivotFormJson(_url, params);
    }

    return this.filterApiCall(_url, params);
  }
  filterApiCall(_url: any, params: any): Observable<any> {
    return this.http.get<ActionResponse>(_url, { params }).pipe(
      switchMap((response: ActionResponse) => {
        if (response.callSuccess == '1') {
          return of(response);
        }
        this.gtwSnackbarService.openSnackBar(
          'oops  the requested data could not be delivered. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        return throwError('Action call failed!');
      })
    );
  }

  filterPivotFormJson(_url: any, params: any): Observable<any> {
    //irsForm is placeholder for other object name within response
    return this.http.get<any>(_url, { params }).pipe(
      switchMap((response: any) => {
        if (response.irsForm.callSuccess == '1') {
          return of(response);
        }
        this.gtwSnackbarService.openSnackBar(
          'oops  the requested data could not be delivered. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        return throwError('Action call failed!');
      })
    );
  }

  saveJSONWParams(_url: any, _data: any, _globalService: any): Observable<any> {
    // var defer = $q.defer();

    let filterParams = this.resolveFilterParams(_globalService);
    let paramsMerge = _.merge({}, filterParams, _data);
    let params = _.merge(
      {},
      _globalService.globalParams,
      paramsMerge
    );

    ///////// TEMP HACK /////////////: This will not be needed when scenario is added to filter try; && (params.scenario == ""|| params.scenario == undefined || params.scenario == null)
    if (params.tax_year && params.tax_year.length) {
      params.scenario = _globalService.getScenario(params.tax_year);
    }

    var checkLockedbj = [];
    var rowData =
    _globalService.workspaceFactory.activeScreen.data &&
    _globalService.workspaceFactory.activeScreen.data.selected &&
    _globalService.workspaceFactory.activeScreen.data.selected.rowData;
    if (_.isArray(rowData) && rowData.length > 0) {
      _.each(rowData, function (item) {
        checkLockedbj.push({
          leid: item.data.LEID || item.data.SOURCE_LEID, //"IF1139",
          me_code:
            item.data.ME_CODE || item.data.ME || item.data.SOURCE_ME_CODE,
          cdr_number:
            item.data.CDR_NO || rowData.TAX_CODE || item.data.SOURCE_CDR_NO,
          consol_group_key:
            item.data.CONSOL_GROUP_KEY || item.data.FILING_GROUP, //1,
          reporting_period:
            item.data.REPORTING_PERIOD || item.data.SOURCE_REPORTING_PERIOD,
          combination_key:
            item.data.COMBINATION_KEY ||
            item.data.COMPL_COMBINATION_KEY ||
            item.data.HO_COMBINATION_KEY, //1,
          scenario_key: item.data.SCENARIO_KEY
            ? item.data.SCENARIO_KEY
            : _data.scenario
            ? _data.scenario
            : filterParams.scenario,
        });
      });
    } else if (rowData) {
      checkLockedbj.push({
        leid: rowData.LEID || rowData.SOURCE_LEID, //"IF1139",
        me_code: rowData.ME_CODE || rowData.ME || rowData.SOURCE_ME_CODE,
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE || rowData.SOURCE_CDR_NO,
        consol_group_key: rowData.CONSOL_GROUP_KEY || rowData.FILING_GROUP, //1,
        reporting_period:
          rowData.REPORTING_PERIOD || rowData.SOURCE_REPORTING_PERIOD,
        combination_key:
          rowData.COMBINATION_KEY ||
          rowData.COMPL_COMBINATION_KEY ||
          rowData.HO_COMBINATION_KEY,
        scenario_key: rowData.SCENARIO_KEY
          ? rowData.SCENARIO_KEY
          : _data.scenario
          ? _data.scenario
          : filterParams.scenario,
      });
    } else {
      checkLockedbj.push({
        scenario_key: _data.scenario ? _data.scenario : filterParams.scenario,
      });
    }

    params.checkLockedbj = JSON.stringify(checkLockedbj);

    console.log('params : ', params);

    let scenarioCode: any = '';
    if (
      _globalService.workspaceFactory.activeScreen &&
      _globalService.workspaceFactory.activeScreen.filters &&
      typeof _globalService.workspaceFactory.activeScreen.filters
        .getFilters === 'function'
    ) {
      /*  scenarioCode =  workspaceFactory.activeScreen.filters.getFilters().length>1 ?
                         _.filter(workspaceFactory.activeScreen.filters.getFilters(),{param_name:'scenario'})[0].selected : '';//_.filter(workspaceFactory.activeScreen.filters.getFilters(),{param_name:'scenario'})[0].selected;

                         _data.scenarioCode = scenarioCode.CODE; */
      let foundScenario: any = {};
      foundScenario = _.find(
        _globalService.workspaceFactory.activeScreen.filters.getFilters(),
        { param_name: 'scenario' }
      );
      if (foundScenario && foundScenario.selected) {
        scenarioCode = foundScenario.selected;
        params.scenarioCode = scenarioCode?.CODE;
        params.is_issue_key_enabled = scenarioCode?.ISSUE_ID_ENABLED;
      }
    } else if (params.scenario) {
      let foundScenario: any;
      _.find(_globalService.inputs.tax_year.values, function (i) {
        if (i.value == params.tax_year) {
          foundScenario = _.find(i.scenarios, { scenario: params.scenario });
        }
      });
      if (foundScenario && foundScenario.scenario_type_code) {
        params.scenarioCode = foundScenario.scenario_type_code;
        params.is_issue_key_enabled = foundScenario.is_issue_key_enabled;
      }
    }
    console.log('params2 : ', params);
    const data = new FormData();
    _.map(params, (v: any, k: any) => {
      data.append(k, v);
    });
    console.log('params3 : ', params);
    return this.http.post(_url, data).pipe(
      map((response: any) => {
        if (response.callSuccess == '1') {
          console.log('params 4', params);
          return response;
        }
        this.gtwSnackbarService.openSnackBar(
          'oops  the requested data could not be delivered. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        throwError(new Error('oops!'));
        return response;
      })
    );
  }

  /**
   * New explicit API for migrated components:
   * saveJSON6(url, data, globalService, componentFilterParams)
   *
   * - Keeps legacy saveJSONWParams(...) unchanged
   * - Allows passing component-level filter params explicitly
   */
  saveJSON6(
    _url: any,
    _data: any,
    _globalService: any,
    _componentFilterParams: any = {}
  ): Observable<any> {
    let filterParams = this.resolveFilterParams(_globalService, _componentFilterParams);

    let paramsMerge = _.merge({}, filterParams, _data);
    let params = _.merge({}, _globalService?.globalParams || {}, paramsMerge);

    if (params.tax_year && params.tax_year.length && _globalService?.getScenario) {
      params.scenario = _globalService.getScenario(params.tax_year);
    }

    let checkLockedbj: any[] = [];
    let rowData =
      _globalService?.workspaceFactory?.activeScreen?.data &&
      _globalService.workspaceFactory.activeScreen.data.selected &&
      _globalService.workspaceFactory.activeScreen.data.selected.rowData;

    if (_.isArray(rowData) && rowData.length > 0) {
      _.each(rowData, function (item: any) {
        checkLockedbj.push({
          leid: item.data.LEID || item.data.SOURCE_LEID,
          me_code: item.data.ME_CODE || item.data.ME || item.data.SOURCE_ME_CODE,
          cdr_number: item.data.CDR_NO || item.data.TAX_CODE || item.data.SOURCE_CDR_NO,
          consol_group_key: item.data.CONSOL_GROUP_KEY || item.data.FILING_GROUP,
          reporting_period: item.data.REPORTING_PERIOD || item.data.SOURCE_REPORTING_PERIOD,
          combination_key:
            item.data.COMBINATION_KEY ||
            item.data.COMPL_COMBINATION_KEY ||
            item.data.HO_COMBINATION_KEY,
          scenario_key: item.data.SCENARIO_KEY
            ? item.data.SCENARIO_KEY
            : _data.scenario
            ? _data.scenario
            : filterParams.scenario,
        });
      });
    } else if (rowData) {
      checkLockedbj.push({
        leid: rowData.LEID || rowData.SOURCE_LEID,
        me_code: rowData.ME_CODE || rowData.ME || rowData.SOURCE_ME_CODE,
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE || rowData.SOURCE_CDR_NO,
        consol_group_key: rowData.CONSOL_GROUP_KEY || rowData.FILING_GROUP,
        reporting_period: rowData.REPORTING_PERIOD || rowData.SOURCE_REPORTING_PERIOD,
        combination_key:
          rowData.COMBINATION_KEY ||
          rowData.COMPL_COMBINATION_KEY ||
          rowData.HO_COMBINATION_KEY,
        scenario_key: rowData.SCENARIO_KEY
          ? rowData.SCENARIO_KEY
          : _data.scenario
          ? _data.scenario
          : filterParams.scenario,
      });
    } else {
      checkLockedbj.push({
        scenario_key: _data.scenario ? _data.scenario : filterParams.scenario,
      });
    }

    params.checkLockedbj = JSON.stringify(checkLockedbj);

    let scenarioCode: any = '';
    if (
      _globalService?.workspaceFactory?.activeScreen &&
      _globalService.workspaceFactory.activeScreen.filters &&
      typeof _globalService.workspaceFactory.activeScreen.filters.getFilters === 'function'
    ) {
      let foundScenario: any = _.find(
        _globalService.workspaceFactory.activeScreen.filters.getFilters(),
        { param_name: 'scenario' }
      );
      if (foundScenario && foundScenario.selected) {
        scenarioCode = foundScenario.selected;
        params.scenarioCode = scenarioCode?.CODE;
        params.is_issue_key_enabled = scenarioCode?.ISSUE_ID_ENABLED;
      }
    } else if (params.scenario && _globalService?.inputs?.tax_year?.values) {
      let foundScenario: any;
      _.find(_globalService.inputs.tax_year.values, function (i: any) {
        if (i.value == params.tax_year) {
          foundScenario = _.find(i.scenarios, { scenario: params.scenario });
        }
      });
      if (foundScenario && foundScenario.scenario_type_code) {
        params.scenarioCode = foundScenario.scenario_type_code;
        params.is_issue_key_enabled = foundScenario.is_issue_key_enabled;
      }
    }

    const data = new FormData();
    _.map(params, (v: any, k: any) => {
      data.append(k, v);
    });

    return this.http.post(_url, data).pipe(
      map((response: any) => {
        if (response.callSuccess == '1') {
          return response;
        }
        this.gtwSnackbarService.openSnackBar(
          'oops  the requested data could not be delivered. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        throwError(new Error('oops!'));
        return response;
      })
    );
  }

  /**
   * Backward-compatible alias for older migrated calls.
   * Prefer saveJSON6 going forward.
   */
  saveJSONWParams6(
    _url: any,
    _data: any,
    _globalService: any,
    _componentFilterParams: any = {}
  ): Observable<any> {
    return this.saveJSON6(_url, _data, _globalService, _componentFilterParams);
  }

  arrObjToLower(_data: any): any[] {
    const dataTrans: any[] = _.map(_data, (x: any) => {
      const lowerObj = _.transform(x, (result: any, val: any, key: any) => {
        if (key != undefined) {
          result[_.toLower(key)] = val;
        }
      });
      return lowerObj;
    }) as any[];
    return dataTrans;
  }
  objToLower(_data: any): any {
    const lowerObj = _.transform(_data, (result: any, val: any, key: any) => {
      result[key.toLowerCase()] = val;
    });

    return lowerObj;
  }
  arrObjToUpper(_data: any): any[] {
    const dataTrans: any[] = _.map(_data, (x: any) => {
      const upperObj = _.transform(x, (result: any, val: any, key: any) => {
        result[key.toUpperCase()] = val;
      });
      return upperObj;
    }) as any[];
    return dataTrans;
  }
}
